import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductSegment } from '../../models/product-segment.enum';
import { UserService } from '../user/user.service';

@Injectable()
export class ProductSegmentGuard {
  constructor(
    private router: Router,
    private userService: UserService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.userHasSegment(+route.paramMap.get('segment'));
  }

  private userHasSegment(segment: ProductSegment): boolean {
    if (this.userService.userHasSegment(segment)) {
      return true;
    } else {
      this.router.navigate(['/dashboard']);
      return false;
    }
  }
}
